import { FetchResult } from '@apollo/client';
import { ServerModels as SM } from 'types/server';

export function toClientSetCheckSettingsResult(
  response: FetchResult<SM.ExcessSetCheckSettingsMutation>,
): SM.ExcessSettingsStatus | null {
  return response.data?.excessSetCheckSettings?.status ?? null;
}
